export default __webpack_public_path__ + "static/media/logo.b944f346.jpg";